export default __webpack_public_path__ + "static/media/spot-icon-noresult.6528123d.svg";